import React from "react";
import { UncontrolledDropdown, DropdownToggle, DropdownMenu, DropdownItem } from "reactstrap";

export const tableColumns = (handleAction) => [
    { dataField: "id", text: "ID", sort: true, headerStyle: { width: '80px' } },
    { dataField: "host", text: "SMTP Host", sort: true },
    { dataField: "port", text: "Port", sort: true },
    { dataField: "user_name", text: "User Name", sort: true },
    { dataField: "encryption", text: "Encryption", sort: true },
    { dataField: "from_email", text: "From Email", sort: true },
    { dataField: "created_at", text: "Created On", sort: true },
    {
        dataField: "status", text: "Status",
        formatter: (cell) => (
            <span className={`badge rounded-pill ${["Active", "Verified"].includes(cell) ? 'bg-success-subtle text-success' : 'bg-danger-subtle text-danger'
                }`} style={{ fontSize: '11px', padding: '5px 10px' }}>
                {cell}
            </span>
        )
    },
    {
        dataField: "actions", text: "Action", headerClasses: "text-end px-4", classes: "text-end px-4", isDummyField: true,
        formatter: (_, row) => (
            <UncontrolledDropdown>
                <DropdownToggle tag="button" className="btn btn-light btn-sm border">
                    <i className="bx bx-dots-horizontal-rounded"></i>
                </DropdownToggle>
                <DropdownMenu className="dropdown-menu-end">
                    <DropdownItem onClick={() => handleAction("View", row)}>
                        <i className="bx bx-show-alt me-2 text-primary"></i> View
                    </DropdownItem>
                    <DropdownItem onClick={() => handleAction("Edit", row)}>
                        <i className="bx bx-pencil me-2 text-success"></i> Edit
                    </DropdownItem>
                    <DropdownItem divider />
                    <DropdownItem className="text-danger">
                        <i className="bx bx-trash me-2"></i> Delete
                    </DropdownItem>
                </DropdownMenu>
            </UncontrolledDropdown>
        ),
    },
];